module.exports = __webpack_public_path__ + "static/media/search-sidebar.9d7e8cd0.svg";